import { render, staticRenderFns } from "./W0089V0001.vue?vue&type=template&id=b84d976a&scoped=true&"
import script from "./W0089V0001.vue?vue&type=script&lang=js&"
export * from "./W0089V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0089V0001.vue?vue&type=style&index=0&id=b84d976a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84d976a",
  null
  
)

export default component.exports